module.exports = __webpack_public_path__ + "img/20180815_145911_027.4a9e4fde.jpg";